import React from "react";
import { FileDown, Users, Wine, ArrowRight } from "lucide-react";
import { useContent } from "../contexts/ContentContext";
import { resolveAssetUrl } from "../lib/api";
import { useReservation } from "./ReservationDialog";

export default function MenuSection() {
    const { t, content, lang } = useContent();
    const { setOpen } = useReservation();
    const cartaPdf = resolveAssetUrl(content?.menu_pdf?.[lang] || content?.menu_pdf?.ca);
    const groupPdf = resolveAssetUrl(content?.groups_pdf?.[lang] || content?.groups_pdf?.ca);
    const winePdf = resolveAssetUrl(content?.wine_pdf?.[lang] || content?.wine_pdf?.ca);

    return (
        <section id="menu" className="relative py-24 md:py-40 bg-white" data-testid="menu-section">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl">
                    <span className="kicker">{t?.menu?.kicker}</span>
                    <h2 className="mt-6 font-display text-4xl md:text-5xl lg:text-6xl text-brand-navy leading-[1.05]" data-testid="menu-title">
                        {t?.menu?.title}
                    </h2>
                    <p className="mt-6 text-base md:text-lg text-slate-600 leading-relaxed">
                        {t?.menu?.subtitle}
                    </p>
                </div>

                <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10">
                    <a
                        href={cartaPdf || "#"}
                        target="_blank"
                        rel="noreferrer"
                        className="group relative bg-brand-cream rounded-3xl p-8 md:p-12 border border-brand-navy/10 hover:border-brand-terracotta transition-all duration-500 hover:shadow-[0_20px_60px_-20px_rgba(35,58,90,0.2)] hover:-translate-y-1 overflow-hidden"
                        data-testid="menu-download-carta"
                    >
                        <div className="flex items-start justify-between mb-12">
                            <div className="w-14 h-14 rounded-full bg-brand-navy text-white flex items-center justify-center">
                                <FileDown size={22} />
                            </div>
                            <ArrowRight size={20} className="text-brand-terracotta transition-transform group-hover:translate-x-2" />
                        </div>
                        <div className="font-display text-4xl md:text-5xl text-brand-navy leading-[1]">
                            {t?.menu?.download_carta}
                        </div>
                        <div className="mt-6 text-xs uppercase tracking-[0.25em] text-brand-blue">PDF · {lang.toUpperCase()}</div>
                    </a>

                    <a
                        href={groupPdf || "#"}
                        target="_blank"
                        rel="noreferrer"
                        className="group relative bg-brand-navy text-white rounded-3xl p-8 md:p-12 hover:shadow-[0_20px_60px_-20px_rgba(35,58,90,0.6)] transition-all duration-500 hover:-translate-y-1 overflow-hidden"
                        data-testid="menu-download-groups"
                    >
                        <div className="flex items-start justify-between mb-12">
                            <div className="w-14 h-14 rounded-full bg-brand-terracotta text-white flex items-center justify-center">
                                <Users size={22} />
                            </div>
                            <ArrowRight size={20} className="transition-transform group-hover:translate-x-2" />
                        </div>
                        <div className="font-display text-4xl md:text-5xl leading-[1]">
                            {t?.menu?.download_menus}
                        </div>
                        <div className="mt-6 text-xs uppercase tracking-[0.25em] text-white/60">PDF · {lang.toUpperCase()}</div>
                    </a>

                    <a
                        href={winePdf || "#"}
                        target="_blank"
                        rel="noreferrer"
                        className="group relative bg-brand-cream rounded-3xl p-8 md:p-12 border border-brand-navy/10 hover:border-brand-terracotta transition-all duration-500 hover:shadow-[0_20px_60px_-20px_rgba(35,58,90,0.2)] hover:-translate-y-1 overflow-hidden"
                        data-testid="menu-download-wine"
                    >
                        <div className="flex items-start justify-between mb-12">
                            <div className="w-14 h-14 rounded-full bg-brand-navy text-white flex items-center justify-center">
                                <Wine size={22} />
                            </div>
                            <ArrowRight size={20} className="text-brand-terracotta transition-transform group-hover:translate-x-2" />
                        </div>
                        <div className="font-display text-4xl md:text-5xl text-brand-navy leading-[1]">
                            {t?.menu?.download_wine}
                        </div>
                        <div className="mt-6 text-xs uppercase tracking-[0.25em] text-brand-blue">PDF · {lang.toUpperCase()}</div>
                    </a>
                </div>

                <div className="mt-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 rounded-2xl border border-brand-navy/10 p-8 bg-brand-cream/60">
                    <p className="font-display text-2xl md:text-3xl text-brand-navy max-w-xl">
                        {t?.contact?.reserve_cta || "Reservar taula"}
                    </p>
                    <button
                        type="button"
                        onClick={() => setOpen(true)}
                        className="btn-primary"
                        data-testid="menu-section-reserve"
                    >
                        {t?.nav?.reserve || "Reservar"}
                        <ArrowRight size={16} />
                    </button>
                </div>
            </div>
        </section>
    );
}
